<template>
  <ModalWindow :isOpen="!!errorMessage" @close="goHome">
    <template #body>
      <p id="error-message" class="is-size-5 has-text-centered mb-3">{{ errorMessage }}</p>
      <fieldset class="buttons is-centered" :disabled="busy">
        <button id="error-logout" type="button" class="button is-link" :class="{ 'is-loading': busy }" @click="logout">
          Log out
        </button>
        <button id="error-return" type="button" class="button" @click="goHome">
          Return to home page
        </button>
      </fieldset>
    </template>
  </ModalWindow>
</template>

<script>
import { msalInstance } from '@/auth/msalInstance';
import { useAuthStore } from '@/store/modules/auth';

export default {
  name: 'LoginCallback',
  data() {
    return {
      errorMessage: null,
      busy: false,
    };
  },
  async mounted() {
    try {
      const response = await msalInstance.handleRedirectPromise();
      if (response?.account) {
        msalInstance.setActiveAccount(response.account);
      }

      const authStore = useAuthStore();
      await authStore.updateAuth();
      
      this.$router.push({ name: 'Home' });
    } catch (err) {
      console.error('Auth error:', err);
      this.errorMessage = err.message || 'Login failed';
    }
  },
  methods: {
    async logout() {
      this.busy = true;
      await msalInstance.logoutRedirect();
    },
    goHome() {
      this.$router.push({ name: 'Home' });
    }
  }
};
</script>